import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

export default function RecommendedSection() {
  const completed = allComics.filter((c) => c.rating >= 9.5).slice(0, 6);

  return (
    <section className="py-14 bg-white" aria-labelledby="recommend-heading">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 id="recommend-heading" className="font-heading text-2xl text-foreground-950 mb-8">
          编辑推荐
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {completed.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-primary-50 transition-colors duration-300"
            >
              <div className="w-[100px] h-[140px] flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 编辑推荐漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h4 className="font-medium text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                    {comic.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{comic.author} · {comic.status}</p>
                  <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed">
                    {comic.description}
                  </p>
                </div>
                <div className="flex items-center gap-2 mt-2">
                  {comic.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}